export default () => {
	if (window["asl_jQuery"] && asl_jQuery.views) {
		asl_jQuery.views.settings.allowCode(true);
		//  svg wrapper
		asl_jQuery.views.tags("svgLoop", function (_field) {
			var uList_html = "";

			if (_field) {
				// var list_items = _field.split(",");
				var num = _field;
				var svgHTML =
					'<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 20.743 20.743"><g transform="translate(2 2)"><g fill="#cac177" stroke="#365069" stroke-width="2"><circle cx="8.372" cy="8.372" r="8.372" stroke="none"/><circle cx="8.372" cy="8.372" r="9.372" fill="none"/></g><path d="M9825.173-256.893a37.559,37.559,0,0,1-4.919,0s-4.851-3.964,9.537-10.232c5.029.07,5.082,0,5.082,0S9822.664-261.792,9825.173-256.893Z" transform="translate(-9817.738 269.255)" fill="#365069"/><path d="M9848.589-248.234s-5.163,3.333-2.333,5.72c3.615.067,4.957,0,4.957,0s-3.613-1.89,1.654-5.72C9848.678-248.417,9848.589-248.234,9848.589-248.234Z" transform="translate(-9837.674 254.8)" fill="#365069"/></g></svg>';
				var list_html = "";
				for (var i = 0; i < num; i++) {
					list_html += "<span class='svg-wrapper'>" + svgHTML + "</span>";
				}
				uList_html = '<div class="lift-chair-svgs">' + list_html + "</div>";
			}
			return uList_html;
		});

		asl_jQuery.views.tags("cssClassGen", function (val) {
			return val.toLowerCase().replace(/ /g, "-");
		});
	}
};
